import React from 'react';
import moment from 'moment';
import { ContentCode, ContentCodeStartType } from 'models/Content';
import Locale from 'localization/Localization';

interface ContentCodeItemProps
{
	code: ContentCode;
	onClick?: (contentCode: ContentCode) => void;
}

interface ContentCodeItemState
{
	enabled: boolean;
	startDate: moment.Moment;
	validFrom: moment.Moment;
	validThru: moment.Moment;
}

export class ContentCodeItem extends React.Component<ContentCodeItemProps, ContentCodeItemState>
{
	public static defaultProps: Partial<ContentCodeItemProps> = {

	};

	constructor(props: ContentCodeItemProps)
	{
		super(props);

		this.state = {
			enabled: this.props.code.active,
			startDate: moment.utc(this.props.code.startTime),
			validFrom: moment.utc(this.props.code.validFrom),
			validThru: moment.utc(this.props.code.validThru)
		};
	}

	public onToggle(checked: boolean)
	{
		this.setState({
			enabled: checked
		});
	}

	private onClick(event: React.MouseEvent<HTMLTableRowElement>)
	{
		if (this.props.onClick !== undefined)
		{
			this.props.onClick(this.props.code);
		}
	}

	public componentDidMount()
	{

	}

	public componentWillUnmount()
	{

	}

	public render()
	{
		return <tr onClick={this.onClick.bind(this)}>
			<td>{this.props.code.contentCode}</td>
			<td>{this.state.validFrom.format(Locale.get('format_date'))} - {this.state.validThru.format(Locale.get('format_date'))}</td>
			<td>
				{
					(this.props.code.startType === ContentCodeStartType.Activation)
						? Locale.get("contentCodeType_Activation")
						: this.state.startDate.format(Locale.get('format_date'))

				}
			</td>
			<td>{this.props.code.activations} / {this.props.code.maxActivations}</td>
			<td>
				{
					this.state.enabled
						? <div className='result-message rm-success'>{Locale.get("contentCode_statusEnabled")}</div>
						: <div className='result-message rm-error'>{Locale.get("contentCode_statusDisabled")}</div>
				}
			</td>
		</tr>;
	}
}